import { Workspace, Insight, User } from '../types/workspace'
// Mock Users
const users: User[] = [
  {
    id: '1',
    name: 'Alice Johnson',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    role: 'Insight Manager',
    email: 'alice@example.com',
  },
  {
    id: '2',
    name: 'Bob Smith',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    role: 'Product Owner',
    email: 'bob@example.com',
  },
  {
    id: '3',
    name: 'Carol Williams',
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    role: 'Marketing Analyst',
    email: 'carol@example.com',
  },
  {
    id: '4',
    name: 'David Miller',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    role: 'Executive',
    email: 'david@example.com',
  },
  {
    id: '5',
    name: 'Eva Chen',
    avatar:
      'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    role: 'Customer Experience',
    email: 'eva@example.com',
  },
]
// Mock Insights
export const mockInsights: Insight[] = [
  {
    id: '1',
    title: 'Users struggle with checkout process',
    description:
      'Analysis of feedback shows 23% of users mention difficulty completing purchases due to a confusing checkout flow.',
    sentiment: 'negative',
    source: 'Customer Survey Q2 2023',
    tags: ['UX', 'Checkout', 'High Priority'],
    author: users[0],
    createdAt: '2023-06-15',
    comments: [
      {
        id: '1',
        text: 'We should prioritize this for the next sprint. The data shows this is affecting conversion rates.',
        author: users[0],
        date: '2 days ago',
      },
      {
        id: '2',
        text: "I agree. Let's schedule a design review to identify the specific pain points.",
        author: users[1],
        date: '1 day ago',
      },
    ],
    actions: [
      {
        id: '1',
        title: 'Schedule design review meeting',
        assignee: users[1],
        dueDate: '2023-07-05',
        completed: false,
      },
      {
        id: '2',
        title: 'Analyze drop-off points in checkout funnel',
        assignee: users[2],
        dueDate: '2023-07-02',
        completed: true,
      },
    ],
  },
  {
    id: '2',
    title: 'Mobile app receives positive feedback on new UI',
    description:
      'Recent app store reviews show a 28% increase in positive sentiment following the UI redesign.',
    sentiment: 'positive',
    source: 'App Store Reviews',
    tags: ['Mobile', 'UI', 'Success'],
    author: users[2],
    createdAt: '2023-06-20',
    comments: [
      {
        id: '3',
        text: 'Great work team! The simplified navigation is really resonating with users.',
        author: users[3],
        date: '3 days ago',
      },
    ],
    actions: [
      {
        id: '3',
        title: 'Prepare case study for marketing team',
        assignee: users[2],
        dueDate: '2023-07-10',
        completed: false,
      },
    ],
  },
  {
    id: '3',
    title: 'Customers requesting better product filtering options',
    description:
      'Analysis of support tickets and social media mentions shows increasing demand for more granular product filtering.',
    sentiment: 'neutral',
    source: 'Support Tickets',
    tags: ['Feature Request', 'Search', 'Medium Priority'],
    author: users[4],
    createdAt: '2023-06-18',
    comments: [],
    actions: [
      {
        id: '4',
        title: 'Research competitor filtering options',
        assignee: users[0],
        dueDate: '2023-07-08',
        completed: false,
      },
    ],
  },
  {
    id: '4',
    title: 'Shipping time complaints increasing in European market',
    description:
      'Customer feedback from Q2 shows a 15% increase in complaints about shipping times in Germany and France.',
    sentiment: 'negative',
    source: 'NPS Survey',
    tags: ['Shipping', 'Europe', 'High Priority'],
    author: users[0],
    createdAt: '2023-06-22',
    comments: [
      {
        id: '5',
        text: 'This is concerning. We need to review our logistics partners in the region.',
        author: users[3],
        date: '1 day ago',
      },
    ],
    actions: [
      {
        id: '5',
        title: 'Analyze shipping data by region',
        assignee: users[4],
        dueDate: '2023-07-01',
        completed: true,
      },
      {
        id: '6',
        title: 'Schedule meeting with logistics team',
        assignee: users[0],
        dueDate: '2023-07-05',
        completed: false,
      },
    ],
  },
]
// Mock Workspaces
export const mockWorkspaces: Workspace[] = [
  {
    id: '1',
    name: 'North America NPS Improvement',
    description:
      'Collaborative workspace to analyze and improve NPS scores in the North American market.',
    createdAt: '2023-06-10',
    lastUpdated: '2 days ago',
    status: 'Active',
    purpose: 'analysis',
    owner: users[0],
    collaborators: [users[0], users[1], users[2], users[3]],
    activities: [
      {
        id: '1',
        type: 'add',
        user: users[0],
        date: '5 days ago',
        description: 'Created workspace',
      },
      {
        id: '2',
        type: 'invite',
        user: users[0],
        date: '5 days ago',
        description:
          'Added Bob Smith, Carol Williams, and David Miller to the workspace',
      },
      {
        id: '3',
        type: 'add',
        user: users[0],
        date: '4 days ago',
        description: 'Added insight "Users struggle with checkout process"',
        target: {
          id: '1',
          title: 'Users struggle with checkout process',
          description:
            'Analysis of feedback shows 23% of users mention difficulty completing purchases due to a confusing checkout flow.',
        },
      },
      {
        id: '4',
        type: 'comment',
        user: users[0],
        date: '3 days ago',
        description: 'Commented on "Users struggle with checkout process"',
        target: {
          id: '1',
          title:
            'We should prioritize this for the next sprint. The data shows this is affecting conversion rates.',
        },
      },
      {
        id: '5',
        type: 'action',
        user: users[1],
        date: '2 days ago',
        description:
          'Created action item "Analyze drop-off points in checkout funnel"',
        target: {
          title: 'Analyze drop-off points in checkout funnel',
        },
      },
      {
        id: '6',
        type: 'action',
        user: users[2],
        date: '1 day ago',
        description:
          'Completed action item "Analyze drop-off points in checkout funnel"',
        target: {
          title: 'Analyze drop-off points in checkout funnel',
        },
      },
      {
        id: '7',
        type: 'decision',
        user: users[3],
        date: '1 day ago',
        description: 'Recorded decision',
        target: {
          title: 'Prioritize checkout redesign for Q3',
          description:
            'Based on the data, we will allocate resources to redesign the checkout experience in Q3.',
        },
      },
    ],
    stats: {
      insights: 4,
      comments: 5,
      actions: 6,
      completedActions: 2,
      decisions: 1,
    },
  },
  {
    id: '2',
    name: 'Q3 Marketing Campaign Analysis',
    description:
      'Workspace for analyzing customer feedback on our summer campaign.',
    createdAt: '2023-06-15',
    lastUpdated: '1 week ago',
    status: 'Active',
    purpose: 'marketing',
    owner: users[2],
    collaborators: [users[2], users[0], users[4]],
    activities: [
      {
        id: '8',
        type: 'add',
        user: users[2],
        date: '2 weeks ago',
        description: 'Created workspace',
      },
      {
        id: '9',
        type: 'invite',
        user: users[2],
        date: '2 weeks ago',
        description: 'Added Alice Johnson and Eva Chen to the workspace',
      },
      {
        id: '10',
        type: 'add',
        user: users[2],
        date: '10 days ago',
        description:
          'Added insight "Mobile app receives positive feedback on new UI"',
        target: {
          id: '2',
          title: 'Mobile app receives positive feedback on new UI',
          description:
            'Recent app store reviews show a 28% increase in positive sentiment following the UI redesign.',
        },
      },
    ],
    stats: {
      insights: 2,
      comments: 3,
      actions: 2,
      completedActions: 1,
      decisions: 0,
    },
  },
  {
    id: '3',
    name: 'Product Roadmap Prioritization',
    description:
      'Collaborative workspace for prioritizing feature requests and product improvements.',
    createdAt: '2023-06-05',
    lastUpdated: '3 days ago',
    status: 'Active',
    purpose: 'product',
    owner: users[1],
    collaborators: [users[1], users[0], users[3], users[4]],
    activities: [],
    stats: {
      insights: 6,
      comments: 12,
      actions: 8,
      completedActions: 5,
      decisions: 3,
    },
  },
]
